// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RMlTST {
    /* Reset start */
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;

    background: transparent;

    color: inherit;
    font: inherit;

    line-height: normal;

    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;

    -webkit-appearance: none;
    /* Reset end */

    font-family: Madefor-Text, Madefor;

    box-sizing: border-box;
    text-align: center;
    border: 1px solid #000;
    display: inline-block;

    transition-duration: 100ms;
    transition-timing-function: linear;
    transition-property: background-color, color, border-color;

    min-width: 84px;
    border-radius: 18px;
    padding: 0 18px;

    cursor: pointer;
}

/* Reset start */
.RMlTST::-moz-focus-inner {
    border: 0;
    padding: 0;
}
.RMlTST:active {
    outline: none;
}
/* Reset end */


.RMlTST:hover {
    background-color: #4c4c4c;
    color: #fff;
}

.YetVrT,
.RMlTST:active {
    color: #fff;
    background-color: #000;
}

.zpif8h {
    color: #000;
    background-color: #fff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `RMlTST`,
	"primary": `YetVrT`,
	"secondary": `zpif8h`
};
export default ___CSS_LOADER_EXPORT___;
